import styled from 'styled-components';
import { Icon } from '../../../../../components/common/icon/Icon';
import { SwiperItemContainer } from '../../../../../components/common/itemContainer/SwiperItemContainer';
import { DIRECT_DEAL_RECENT_DAYS } from '../../../../../constants/filter/directDealFilter.constant';
import { useGetOpenMarketProductsQuery } from '../../../../../hooks/api/product/queries/useGetOpenMarketProducts.query';
import { useAppDispatch, useAppSelector } from '../../../../../hooks/store/useStore';
import { filterSlice } from '../../../../../store/filterSlice';
import { formatDateFromTodayOnlyDifference } from '../../../../../utils/formatter/formatDateFromTodayOnlyDifference.util';
import { OpenMarketProductPreviewCard } from '../../../../../views/Product/listView/OpenMarketProductPreviewCard/OpenMarketProductPreviewCard';

const FILTER_TYPE = 'directDealFilter';

const MAX_PRODUCT_COUNT = 10;
const MIN_PRODUCT_COUNT_TO_EXPOSE = 3;
const SLIDE_WIDTH = 142;

export const DirectDealRecentProductSection = () => {
  const dispatch = useAppDispatch();
  const filterActions = filterSlice.actions;
  const directDealFilters = useAppSelector((state) => state.filter.directDealFilter.globalFilters);

  // 끌올 여부와 관계없이 승인일이 최근인 판매 중 매물만 보여 준다.
  const { data: products } = useGetOpenMarketProductsQuery({
    searchParam: {
      status: 'ONSALE',
      count: MAX_PRODUCT_COUNT,
      page: 1,
      machineType: '',
      sort: 'approvalDate_desc',
      recentDays: DIRECT_DEAL_RECENT_DAYS,
    },
  });

  // '전체보기'는 리스트에 등록 기간 조건을 적용한다.
  const handleShowAllButtonClick = () => {
    const recentDaysFilter = directDealFilters.find((filter) => filter.key === 'recentDays');
    const recentDaysOption = recentDaysFilter?.options[0];

    if (recentDaysFilter && recentDaysOption && !recentDaysOption.isSelected) {
      dispatch(
        filterActions.changeFilterOptionIsSelected({
          filterType: FILTER_TYPE,
          targetFilter: recentDaysFilter,
          targetOption: recentDaysOption,
        }),
      );
    }
  };

  if (!products || products.length < MIN_PRODUCT_COUNT_TO_EXPOSE) {
    return null;
  }

  return (
    <Container>
      <Header>
        <SectionTitle>{`최근 ${DIRECT_DEAL_RECENT_DAYS}일간 올라온 매물 보기`}</SectionTitle>
        <ShowAllButton onClick={handleShowAllButtonClick}>
          <ShowAllButtonText>{'전체보기'}</ShowAllButtonText>
          <Icon name={'AngleRight'} size={'Small'} fill={'#505363'} />
        </ShowAllButton>
      </Header>

      <SwiperItemContainer
        slideItemWidth={SLIDE_WIDTH}
        slideItems={products.map((product) => (
          <OpenMarketProductPreviewCard
            key={product.id}
            product={product}
            pageType={'olp'}
            imageChipText={formatDateFromTodayOnlyDifference(String(product.approvalDate))}
          />
        ))}
      />
    </Container>
  );
};

const Container = styled.section`
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 16px;

  padding: 0px 16px 24px 16px;

  overflow: hidden;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const SectionTitle = styled.h2`
  color: var(--Light-Scheme-Monochrome-black, #232429);

  /* Display/XLarge/xl-bold */
  font-family: Pretendard;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 23.4px */
`;

const ShowAllButton = styled.button`
  display: flex;
  align-items: center;
  gap: 2px;
`;

const ShowAllButtonText = styled.span`
  color: var(--Light-Scheme-Monochrome-grey120, #505363);

  /* Display/Medium/m-regular */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 18.2px */
`;
